
<div class="mb-dialog-rate-unavailable">
  <mb-dialog-body class="dialog-body">
    <div class="dialog-body__icon--mobile">
      <mb-icon icon="world"> </mb-icon>
    </div>
    <h3>La habitación no está disponible.</h3>
    <img alt="" src="/hotels/dist/es-AR/browser/assets/images/destination-not-available.svg">
    <p>
      <strong>Pero no te preocupes,</strong> encontramos alternativas que se ajustan perfecto a lo que estabas buscando.
    </p>
  </mb-dialog-body>
  <mb-dialog-footer>
    <button mb-button color="secondary" variant="floating" (click)="refreshPage()">
      Actualizar resultados
    </button>
    <button mb-button color="secondary" (click)="closeDialog()">
      Ver opciones
    </button>
  </mb-dialog-footer>
</div>

